import { Shield, Warehouse, Factory, Building2, Truck, Users, History, MessageSquare, PanelsTopLeft } from 'lucide-react'
import { hasAccess, canViewDrivers, canViewGuards } from 'utils/access'

const ADMIN_TABS = [
  { key: 'kpp', access: 'guards', icon: Shield, label: 'Охрана КПП' },
  { key: 'top', access: 'top_bases', icon: Warehouse, label: 'ТОП-базы' },
  { key: 'chpp', access: 'chpps', icon: Factory, label: 'ТЭЦ' },
  { key: 'private', access: 'private_points', icon: Building2, label: 'Социальные объекты' },
  { key: 'integrations', access: 'loads', icon: PanelsTopLeft, label: 'Интеграции' },
  { key: 'loads', access: 'loads', icon: Truck, label: 'Погрузки' },
  { key: 'drivers', access: 'drivers', icon: Truck, label: 'Транспорт' },
  { key: 'users', access: 'users', icon: Users, label: 'Пользователи' },
  { key: 'audit', access: 'audit', icon: History, label: 'Логирование' },
  { key: 'komursvyaz', icon: MessageSquare, label: 'КомурСвязь' },
]

export function getAdminTabs(user) {
  return ADMIN_TABS.filter(tab => tab.key === 'drivers' ? canViewDrivers(user)
    : tab.key === 'kpp' ? canViewGuards(user)
    : tab.key === 'komursvyaz' ? user.is_superuser || user.is_personal_kyrgyzkomur : hasAccess(user, tab.access))
}
